export const nicerLog = (message?: any, ...optionalParams: any[]) => {
  // eslint-disable-next-line no-console
  return console.log(
    `%c ${message}`,
    'color: white; font-weight: bold; background-color: crimson;padding: 2px;padding-right: 10px;border: 2px solid yellow'
  )
}
